import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom'; // Import Link for navigation

// const PRIMARY_ACCENT_COLOR = "#FF007A"; // This was unused
// const HOVER_TEXT_ACCENT_COLOR = "#FDB4D0"; // This was unused
// const SECTION_BACKGROUND_COLOR = "#374151"; // This was unused
const LINK_TEXT_COLOR = "#60A5FA"; // blue-400
const LINK_TEXT_HOVER_COLOR = "#93C5FD"; // blue-300
const STAT_SECTION_BG_COLOR = "#1E3A8A"; // blue-900
const STAT_DETAIL_TEXT_COLOR = "#BFDBFE"; // blue-200

const caseStudies = [
  {
    stat: "60%",
    statDetail: "Cost Reduction",
    title: "AWS Cost Optimization",
    description: "Enabled a client to achieve a 60% reduction in AWS costs by optimizing their multi-environment infrastructure. We unified services under AWS Organizations, transitioned to on-demand models, and aligned Savings Plans, ensuring sustained cost control.",
    slug: "cost-reduction" // Used for URL path
  },
  {
    stat: "99.999%",
    statDetail: "Availability Achieved",
    title: "Enterprise Landing Page Reliability",
    description: "Resolved frequent landing page downtime for a >$5M company, achieving 99.999% availability. We optimized their auto-scaled environment by implementing pre-baked AMIs and AWS CodeDeploy for faster, reliable deployments.",
    slug: "enterprise-reliability" // Used for URL path
  }
];

const ProjectsSection = () => {
  return (
    <div id="projects" className="py-16 bg-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-3xl font-extrabold text-white sm:text-4xl">
            Our Success Stories
          </h2>
          <p className="mt-4 max-w-2xl text-xl text-gray-300 mx-auto">
            See how we've helped businesses optimize their AWS infrastructure and achieve significant results.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 lg:grid-cols-2 gap-8">
          {caseStudies.map((study) => (
            <div key={study.slug} className="bg-gray-900 rounded-lg overflow-hidden border border-gray-700 flex flex-col">
              <div className="flex flex-col md:flex-row h-full">
                <div 
                  style={{ backgroundColor: STAT_SECTION_BG_COLOR }} 
                  className="md:w-2/5 flex items-center justify-center p-6"
                >
                  <div className="text-center">
                    <div className="text-4xl font-bold text-white">{study.stat}</div>
                    <div style={{color: STAT_DETAIL_TEXT_COLOR}} className="mt-1 text-lg">{study.statDetail}</div>
                  </div>
                </div>
                <div className="md:w-3/5 p-6 flex flex-col justify-between">
                  <div>
                    <h3 className="text-xl font-semibold text-white">{study.title}</h3>
                    <p className="mt-2 text-gray-300 flex-grow">
                      {study.description}
                    </p>
                  </div>
                  <Link 
                    to={`/success-stories/${study.slug}`} 
                    style={{ color: LINK_TEXT_COLOR }} 
                    onMouseOver={(e) => e.currentTarget.style.color = LINK_TEXT_HOVER_COLOR}
                    onMouseOut={(e) => e.currentTarget.style.color = LINK_TEXT_COLOR}
                    className="mt-4 inline-flex items-center font-medium transition-colors duration-150 self-start">
                    Read case study <ArrowRight className="ml-1 h-4 w-4" />
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProjectsSection; 